
import lodash from "lodash"

var LegsTimelineReader = {
  get_source: function(timeline){
    if(timeline.frames){
      return "riot"
    }else if(timeline.gameFrames){
      return "tencent"
    }else{
      return
    }
  },
  get_all_events: function(timeline){


    var source = this.get_source(timeline)

    var gameFrames
    if(source == "riot"){
      gameFrames = timeline.frames
    }else{
      gameFrames = timeline.gameFrames
    }

    var events = []
    lodash.each(gameFrames, function(frame){

      lodash.each(frame.events, function(event){
        events.push(event)
      })
    })

    return events
  },
  get_frame_interval: function(timeline){

    var source = this.get_source(timeline)

    if(source == "riot"){
      return timeline.frameInterval / 1000
    }else{
      return timeline.frameIntervalMillis / 1000
    }
  },
  get_all_frames: function(timeline){

    var source = this.get_source(timeline)

    var gameFrames
    if(source == "riot"){
      gameFrames = timeline.frames
    }else{
      gameFrames = timeline.gameFrames
    }

    var frames = []
    var frameMinute = 0
    lodash.each(gameFrames, function(frame){

      var minuteFrame = {}
      minuteFrame.minute = frameMinute

      lodash.each(frame.participantFrames, function(partFrame, _partId){
        var partId = partFrame.participantId || _partId
        minuteFrame[partId] = partFrame
      })

      frames.push(minuteFrame)

      frameMinute += 1
    })

    return frames
  }

}

export default LegsTimelineReader